import makeRequest from 'api/'

export const getRoleList = async () => {
  return await makeRequest({
    method: 'get',
    url: '/role'
  })
}